
class RewardSource {
    constructor(API) {
        this.API = API;
    }

     async available() {
         return await this.API.get('/index.php?route=api/reward/available')
     }
     async statistics() {
         return await this.API.get('/index.php?route=api/customer/loyalty/statistics')
     }
     async transactions(params) {
         return await this.API.get('/index.php?route=api/customer/loyalty/transactions', { params })
     }
    async remove() {
        return await this.API.post('/index.php?route=api/reward/clear')
    }
    async setReward(data) {
        return await this.API.post("/index.php?route=api/reward/set", data)
    }
}

export default RewardSource
